module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-calendar-worktime"
    }
  }, [_c('hrms-calendar-work-time')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fee04c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoCalendarWorktime.vue
// module id = 3853
// module chunks = 1